<div id="tour-darker-screen" class="tour-darker-screen" *ngIf="showTourBackground"></div>
<s-analytics-header [employees]="activeEmployees"></s-analytics-header>
<s-loader-block-ui [show]="isLoading">
	<div class="sds-container" id="page-content">
		<p-toast [baseZIndex]="10002"></p-toast>
		<hcm-breadcrumb></hcm-breadcrumb>
		<router-outlet></router-outlet>
	</div>
</s-loader-block-ui>
